import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=ee0e6ba8&scoped=true&"
import script from "./Statuses.vue?vue&type=script&lang=ts&"
export * from "./Statuses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0e6ba8",
  null
  
)

export default component.exports